import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import { browserHistory } from './browserHistory';
import { store } from './store';
import { exposeToGlobalScope } from './utils/utilsGlobal';
import { App } from './components/App';
import './styles/index.scss';

ReactDOM.render(
  <Provider store={store}>
    <Router history={browserHistory}>
      <App/>
    </Router>
  </Provider>,
  document.getElementById('react-root')
);

exposeToGlobalScope('version', process.env.ELIXIRCHAT_VERSION);
